module.exports = __webpack_public_path__ + "static/html-60f0519e3dd44f341dd1550b1ebaa02d.jpg";